import React from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

import Paykassma from "features/payment/view/Paykassma";
import Flouci from "features/payment/view/Flouci";

const useSuAdminPayment = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [activeMethod, setActiveMethod] = React.useState(false);
  const [methodIsOpen, setMethodIsOpen] = React.useState(false);

  const openMethod = (method) => {
    setActiveMethod(method);
    setMethodIsOpen(true);
  };

  const closeMethod = () => {
    setMethodIsOpen(false);
  };

  const getActivePaymentMethod = () => {
    switch (activeMethod) {
      case 'paykassma':
        return <Paykassma />
      // case 'flouci':
      //   return <Flouci />
      default:
        return null;
    }
  };

  return {
    history,
    activeMethod,
    methodIsOpen,
    openMethod,
    closeMethod,
    getActivePaymentMethod,
  }
};

export default useSuAdminPayment;